const finEaseUserNavigationRoutes = {
  NPS_OVERVIEW: "/nps-overview",
  NPS_USER_LIST: "/user-list",
} as const;

export default finEaseUserNavigationRoutes;
